export default __webpack_public_path__ + "59c603776011628e249cbdfc9f86945b.svg";